import axios from "axios";
import { BACKEND_URL } from "../../backendURL";


class PatronagerService {

    getReferredList(filters, token) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const api_url = BACKEND_URL + "/api/patronage/my-referenced-voters/";

        return axios.get(api_url, config);
    };

    addReferredByPatronager(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        let request_url = BACKEND_URL + "/api/patronage/voter-reference/";

        return axios.post(request_url, data, config);
    }

    getVoterSearchByNid(token, nid) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        let request_url = BACKEND_URL + "/api/patronage/voter-search-nid/?nid=" + nid;

        return axios.get(request_url, config);
    }

    deleteReferred(token, referredId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        let request_url = BACKEND_URL + "/api/patronage/voter-reference/" + referredId + "/";

        return axios.delete(request_url, config);
    }


    getMyPatronagersList(token, filters) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const api_url = BACKEND_URL + "/api/patronage/myvoters-colors/";

        return axios.get(api_url, config);
    };


    exportMyPatronagerListToExcel(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            responseType: 'blob',
        };

        const api_url = BACKEND_URL + "/api/patronage/patronaged/excel/";

        return axios.get(api_url, config);
    }


    getPoliticalPreferencesList(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/patronage/politicalpreference/";

        return axios.get(api_url, config);
    };


    getEmigrantCountriesList(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/patronage/country-emigrant/";

        return axios.get(api_url, config);
    };


    updateVoterPartyDetails(token, data, voterId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            }
        };

        let request_url = BACKEND_URL + "/api/patronage/patronager/voter-update/" + voterId + "/";

        return axios.put(request_url, data, config);
    }


    getVotingDayList() {
        const token = JSON.parse(localStorage.getItem('authUser'));
        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        const requestUrl = BACKEND_URL + "/api/patronage/my-patronager-voters-election-day/";
        return axios.get(requestUrl, config);
    };


    confirmVote(token, patronagerVoterId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const data = {};

        const requestUrl = BACKEND_URL + "/api/patronage/patronager-voter-confirm-voting/" + patronagerVoterId + "/";
        return axios.put(requestUrl, data, config);
    };


    deleteVote(token, patronagerVoterId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const data = {};

        const requestUrl = BACKEND_URL + "/api/patronage/patronager-voter-cancel-voting/" + patronagerVoterId + "/";
        return axios.put(requestUrl, data, config);
    };

}

export default new PatronagerService();